import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  dashboardRoot: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    // backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    width: 500,
    height: 450,
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: 'translateZ(0)',
  },
  titleBar: {
    background:
      'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, '
      + 'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
  },
  icon: {
    color: 'white',
  },
  headerStyle: {
    flexDirection: 'row-reverse',
    backgroundColor: 'black',
    width: '100%',
    // zIndex: '1',
    paddingBottom: '1px',
    // left: '18%',
    zIndex: theme.zIndex.drawer + 1,
  },
  header2Style: {
    // flexDirection: "row-reverse",
    backgroundColor: '#FFBF00',
    width: '100%',
    // zIndex: '1',
    height: '1vw',
    marginTop: '5%',
  },
  root: {
    flexGrow: 1,
    // flexDirection: 'column'
  },
  styledDrawer: {
    width: '18vw',
    backgroundColor: '#2d2d2d',
    color: 'grey',
    height: '100vh',
    // top: '15%',
    flexShrink: '0',
    zIndex: '0',
    position: 'relative',
  },
  '@global': {
    '.MuiDrawer-paper': {
      zIndex: '0',
    },
    '.MuiListItemIcon-root': {
      color: 'grey',
    },
    '.makeStyles-nested-2': {
      color: '#FFBF00',
    },
    // '.MuiListItem-root:hover': {
    //   color: '#FFBF00',
    // },
    // '.MuiListItemIcon-root:hover': {
    //   color: '#FFBF00',
    // },
  },
  drawerpaper: {
    width: '18vw',
    borderRight: 'none',
    backgroundColor: '#2d2d2d',
    color: 'grey',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  drawerContainer: {
    overflow: 'hidden',
    backgroundColor: '#2d2d2d',
  },
  styledDivider: {
    backgroundColor: 'grey',
    margin: '5% 0',
  },
  sageMaker: {
    // position: 'absolute',
    // bottom: '100px',
    marginTop: '50%',
  },
  userGuideMenu: {
    marginTop: '65%',
  },
  faqsMenu: {
    // position: 'absolute',
    // bottom: '11px',
  },
  badgeRoot: {
    marginRight: '15px',
  },
  logo: {
    maxWidth: '180px',
    // width: 'auto',
    backgroundColor: '#2d2d2d',
    // height: '220px',
  },
  divContent: {
    width: '100%',
    margin: 'auto',
    marginBottom: '5%',
  },
  divContentH2: {
    textAlign: 'center',
    fontWeight: 'bold',
    width: '50%',
    marginLeft: '27%',
    // fontSize: '2.5em',
  },
  divContentH3: {
    textAlign: 'center',
    width: '50%',
    marginLeft: '27%',
  },
  svgStyles: {
    width: '100%',
    backgroundPosition: 'inherit',
    backgroundSize: 'contain',
    padding: '11%',
    paddingBottom: '1px',
  },
  pageNotFound: {
    padding: '20% 0 27% 0',
    // backgroundColor: '#2d2d2d',
    fontSize: '30px',
    color: '#FFBF00',
    textAlign: 'center',
  },
  mainContainerColor: {
    backgroundColor: '#E6E6E6',
  },
  reportScroll: {
    // overflowY: 'scroll',
    // maxHeight: '186px',
    // '@media (max-width:959px)': { // eslint-disable-line no-useless-computed-key
    //   maxHeight: '47px',
    // },
  },
  toolbar: theme.mixins.toolbar,
  menuButton: {
    marginRight: theme.spacing(2),
    // [theme.breakpoints.up('sm')]: {
    //   display: 'none',
    // },
    // [theme.breakpoints.up('md')]: {
    //   display: 'none',
    // },
  },
  closeMenuButton: {
    marginRight: 'auto',
    marginLeft: 0,
  },
  dashBoardListItem: {
    marginTop: '29px',
  },
  searchIconMargin: {
    margin: theme.spacing(1),
  },
  incompatible: {
    textAlign: 'center',
    padding: '25%',
    backgroundColor: '#2d2d2d',
    color: 'red',
    fontSize: '25px',
    fontWeight: 'bold',
  },
  searchReportError: {
    backgroundColor: '#e6e6e6',
    width: '100%',
    textAlign: 'center',
    fontSize: '20px',
    marginTop: '25px',
  },
  iFrame: {
    backgroundColor: '#e6e6e6',
  },
  removeIcon: {
    height: '20px',
    width: '20px',
  },
  requestReport: {
    padding: '0 3% 0 3%',
  },
  formControl: {
    width: '100%',
    margin: theme.spacing(1),
    minWidth: 120,
  },
  reporDropdown: {
    width: '100%',
    // margin: '15px 0 15px 0',
    margin: theme.spacing(1),
  },
  newReportName: {
    width: '100%',
    // margin: '15px 0 15px 0',
    margin: theme.spacing(1),
  },
  description: {
    width: '100%',
    // margin: '15px 0 15px 0',
    margin: theme.spacing(1),
  },
  formButtons: {
    // margin: '15px 0 15px 0',
    margin: theme.spacing(1),
    marginTop: '3%',
  },
  requestReportHead: {
    margin: theme.spacing(1),
  },
  radioGroup: {
    margin: theme.spacing(1),
  },
  submitButton: {
    marginRight: '15px',
    backgroundColor: '#2d2d2d',
    color: '#e6e6e6',
    '&:hover': {
      color: '#FFBF00',
      backgroundColor: '#2d2d2d',
    },
  },
  radioButton: {
    color: '#FFBF00',
    '&:hover': {
      color: '#FFBF00',
    },
    '&$checked': {
      color: '#FFBF00 !important',
    },
  },
  checked: {},
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  loaderColor: {
    color: '#FFBF00',
  },
  helperText: {
    color: '#f44336',
  },
  userGuide: {
    margin: '2% 0 0 3%',
  },
  accordian: {
    backgroundColor: '#EFEFEF',
    minHeight: 56,
    margin: '12px 0',
  },
  accSummHeading: {
    margin: '12px 0',
    fontWeight: 600,
  },
  guidePDFButton: {
    '&:hover': {
      color: '#FFBF00',
      backgroundColor: '#2d2d2d',
    },
  },
  guideVideoButton: {
    '&:hover': {
      color: '#FFBF00',
      backgroundColor: '#2d2d2d',
    },
  },
  avatarRole: {
    width: '100%',
    maxWidth: 360,
  },
  noDasboardGrid: {
    marginLeft: '10%',
    boxShadow: 'none',
  },
  noDasboardList: {
    padding: '0 0 0 25px',
  },
  supportEmail: {
    color: '#0000ff',
    textDecoration: 'underline',
  },
  atos: {
    color: '#d2691e',
  },
  bulletIconSpan: {
    margin: '0 15px 25px 0',
  },
  bulletIcon: {
    width: '8px',
    height: '8px',
  },
}), { index: 1 });

export default useStyles;
